import { render, staticRenderFns } from "./WithdrawRouter.vue?vue&type=template&id=5d3b074e"
import script from "./WithdrawRouter.vue?vue&type=script&lang=js"
export * from "./WithdrawRouter.vue?vue&type=script&lang=js"
import style0 from "./WithdrawRouter.vue?vue&type=style&index=0&id=5d3b074e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports